import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingPeriod  {
    _originalTypeClassName = "zERP.BO.AccountingPeriod";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingPeriod.translate = translateService;
}
this.AccountingPeriodID = null;
this.OrderNo = null;
this.Name = null;
this.StartDate = null;
this.EndDate = null;
this.MonthInt = null;
this._key = this.AccountingPeriodID = 0; 
}

static translate: TranslateService;
_key: any;
private _AccountingPeriodID:any;
get AccountingPeriodID(): any {
    return this._AccountingPeriodID;
  }
set AccountingPeriodID(value: any) {
    this._AccountingPeriodID = value;
    this._key = value;
  }
OrderNo:any;
Name:any;
StartDate:any;
EndDate:any;
MonthInt:any;
FiscalPeriod:any;
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
if (oldValue != null) {
Domain.FiscalPeriod.removeAccountingPeriods(oldValue, $this);
}
Domain.FiscalPeriod.addAccountingPeriods(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountingPeriodID == null || $this.AccountingPeriodID == 0;
            }


}